import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=f157254a&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=f157254a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f157254a",
  null
  
)

export default component.exports